var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, makeStyles } from "@material-ui/core";
import { useCallback } from "react";
import { useHistory } from "react-router";
import { Text } from "..";
var useStyles = makeStyles(function (theme) { return ({
    hover: {
        cursor: "pointer",
    },
    link: {
        color: theme.palette.text.primary,
        "&:hover": {
            color: theme.palette.text.secondary,
        },
    },
}); });
export var Link = function (_a) {
    var href = _a.href, _b = _a.external, external = _b === void 0 ? false : _b, children = _a.children;
    var classes = useStyles();
    var history = useHistory();
    var handleClick = useCallback(function () {
        if (external) {
            var newWindow = window.open(href, "_blank", "noopener,noreferrer");
            if (newWindow) {
                newWindow.opener = null;
            }
        }
        else {
            history.push(href);
        }
    }, [external, href, history]);
    return (_jsx(Box, __assign({ component: "a", className: classes.hover, onClick: handleClick }, { children: _jsx(Text, __assign({ align: "center", className: classes.link }, { children: children }), void 0) }), void 0));
};
